<template>
  <div>
    <PlayNotif ref="MyPlayNotif" :MsgType="typeSound" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import socketIO from "socket.io-client";
import PlayNotif from "../components/PlayNotif.vue";

export default {
  components: {
    PlayNotif
  },
  data() {
    return {
      typeSound: ''
    }
  },
  props: {

  },
  computed: {
    ...mapGetters(['baseUrl', 'appToken', "auth"])
  },
  mounted() {

    if ('serviceWorker' in navigator) {
      //window.addEventListener('load', () => {
        navigator.serviceWorker.register('/driver/socket-worker.js')
          .then((registration) => {
            console.log('سرویس‌ورکر با دامنه ثبت شد:', registration.scope);
          })
          .catch((error) => {
            console.error('ثبت سرویس‌ورکر ناموفق بود:', error);
          });
     // });
    }
    
    //document.addEventListener('deviceready', this.setupBackgroundMode, false);
    var socket = new socketIO('https://socket.taxi133-bnd.ir', {
      transports: ['websocket'],
      jsonp: false,
      reconnection: true, 
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
    });

    var auth = JSON.parse(localStorage.getItem('auth'));
    function connectSocket() {
      if (!socket.connected) {
        socket.connect();
        socket.emit('connected', { room: auth.token });
      }
      console.log('Socket connection status: ', socket.connected);
    }
    connectSocket();

    socket.on('api_service', (socket) => {
      console.log('socket', socket);
      var action = socket.action;
      this.typeSound = action;
      this.reloadPlayNotif(action);
    });

    socket.on('connect', () => {
      console.log('Connected to socket server');
    });

     // به‌طور اختیاری، می‌توانید منطق زیر را برای مدیریت پیام‌ها از سرویس‌ورکر اضافه کنید
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('پیام از سرویس‌ورکر:', event.data);
      });

  },
  created() {
  },
  methods: {
    reloadPlayNotif(action) {
      this.$refs.MyPlayNotif.getdatafromsocket(action);
    },
  },
  watch: {
  },
}
</script>

<style scoped>
button {
  margin: 10px;
}
</style>


